export { AccessiBeWidget } from "./accessi-be-widget";
